const ApproveModal = ({ showModal, onApprove, onCancel }) => {
    if (!showModal) return null;
  
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-10 font-poppins">
        <div className="bg-white p-6 rounded-lg shadow-lg w-96">
          <h2 className="text-lg font-semibold text-gray-800">
            Are you sure you want to approve this item?
          </h2>
          <div className="mt-4 flex justify-end space-x-4">
            <button
              onClick={onCancel}
              className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500"
            >
              Cancel
            </button>
            <button
              onClick={onApprove}
              className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
            >
              Approve
            </button>
          </div>
        </div>
      </div>
    );
  };
  
  export default ApproveModal;
  